<!-- 任务区域：标题 + 副标题 + 任务卡片列表 + 底部链接 -->
<script lang="ts">
  import { _ as t } from "svelte-i18n";
  import TaskCard from "./TaskCard.svelte";

  let {
    openAccountDisabled = false,
    depositDisabled = false,
    tradeDisabled = false,
    ipoDisabled = false,
    onOpenAccount = undefined,
    onDeposit = undefined,
    onTrade = undefined,
    onIpo = undefined,
    onMoreRewards = undefined,
  }: {
    /** 去开户按钮是否禁用（内嵌时置灰） */
    openAccountDisabled?: boolean;
    /** 去入金按钮是否禁用（不在白名单时置灰） */
    depositDisabled?: boolean;
    /** 去交易按钮是否禁用（不在白名单时置灰） */
    tradeDisabled?: boolean;
    /** 去认购按钮是否禁用 */
    ipoDisabled?: boolean;
    /** 去开户 */
    onOpenAccount?: () => void;
    /** 去入金 */
    onDeposit?: () => void;
    /** 去交易 */
    onTrade?: () => void;
    /** 去認購 */
    onIpo?: () => void;
    /** 获取更多奖励 */
    onMoreRewards?: () => void;
  } = $props();
</script>

<div class="flex flex-col items-center w-full mt-[16px]">
  <!-- 标题 -->
  <h3 class="text-[18px] font-semibold text-text-h1 mb-[18px]">
    {$t("task_section_title")}
  </h3>

  <!-- 任务卡片列表 -->
  <div class="flex flex-col gap-[16px] w-full">
    <TaskCard
      title={$t("task_open_account_title")}
      subtitle={$t("task_open_account_subtitle")}
      desc={$t("task_open_account_desc")}
      buttonLabel={$t("task_open_account_btn")}
      chanceLabel={$t("task_chance_label")}
      disabled={openAccountDisabled}
      onAction={onOpenAccount}
    />
    <TaskCard
      title={$t("task_trade_title")}
      subtitle={$t("task_trade_subtitle")}
      desc={$t("task_trade_desc")}
      buttonLabel={$t("task_trade_btn")}
      chanceLabel={$t("task_chance_label")}
      disabled={tradeDisabled}
      onAction={onTrade}
    />
    <TaskCard
      title={$t("task_deposit_title")}
      subtitle={$t("task_deposit_subtitle")}
      desc={$t("task_deposit_desc")}
      buttonLabel={$t("task_deposit_btn")}
      chanceLabel={$t("task_deposit_chance_label")}
      disabled={depositDisabled}
      onAction={onDeposit}
    />
    <TaskCard
      title={$t("task_ipo_title")}
      subtitle={$t("task_ipo_subtitle")}
      desc={$t("task_ipo_desc")}
      buttonLabel={$t("task_ipo_btn")}
      chanceLabel={$t("task_chance_label")}
      disabled={ipoDisabled}
      onAction={onIpo}
    />
    <TaskCard
      title={$t("task_normal_prize_title")}
      subtitle={$t("task_normal_prize_subtitle")}
      desc={$t("task_normal_prize_desc")}
      chanceLabel={$t("task_normal_prize_chance_label")}
      showButton={false}
    />
  </div>

  <!-- 底部链接 -->
  <button
    class="mt-[24px] mb-[19px] text-[14px] text-primary-color font-normal"
    type="button"
    onclick={onMoreRewards}
  >
    {$t("task_more_rewards")}
  </button>
</div>
